// Configuration
const tests = {
  'TEST001': {
    enabled: false,
    variants: {
      'A': {
        productProperties: [
          { pathnames: ['/products/balance-bike', '/products/14-inch-bike', '/products/16-inch-bike', '/products/20-inch-small-bike', '/products/20-inch-large-bike', '/products/24-inch-bike', '/products/26-inch-bike'], key: "_gbab", value: "T001-A" }
        ],
        selectors: [
        //   {element: '.product-template[data-product-id=\"6777668730973\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 1000},
        //   {element: '.product-template[data-product-id=\"6777668730973\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 1000},
        //   {element: '.product-template[data-product-id=\"4837251022941\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 1000},
        //   {element: '.product-template[data-product-id=\"4837251022941\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 1000},
        //   {element: '.product-template[data-product-id=\"4837240602717\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 1000},
        //   {element: '.product-template[data-product-id=\"4837240602717\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 1000},
          {element: '.product-template[data-product-id=\"4837430001757\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 1000},
          {element: '.product-template[data-product-id=\"4837430001757\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 1000},
          {element: '.product-template[data-product-id=\"4837426954333\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 1000},
          {element: '.product-template[data-product-id=\"4837426954333\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 1000},
          {element: '.product-template[data-product-id=\"4837430394973\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 1000},
          {element: '.product-template[data-product-id=\"4837430394973\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 1000},
        //   {element: '.product-template[data-product-id=\"6971986903133\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 1000},
        //   {element: '.product-template[data-product-id=\"6971986903133\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 1000},
        //   {element: '.collection_with_options-grid-item[data-product="balance-bike"] .collection_with_options-price', type: 'innerText', value: '$149' },
        //   {element: '.collection_with_options-grid-item[data-product="14-inch-bike"] .collection_with_options-price', type: 'innerText', value: '$249' },
        //   {element: '.collection_with_options-grid-item[data-product="16-inch-bike"] .collection_with_options-price', type: 'innerText', value: '$249' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-small-bike"] .collection_with_options-price', type: 'innerText', value: '$289' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-large-bike"] .collection_with_options-price', type: 'innerText', value: '$319' },
          {element: '.collection_with_options-grid-item[data-product="24-inch-bike"] .collection_with_options-price', type: 'innerText', value: '$339' },
        //   {element: '.collection_with_options-grid-item[data-product="26-inch-bike"] .collection_with_options-price', type: 'innerText', value: '$399' },
        //   {element: '.collection_with_options-grid-item[data-product="balance-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$199' },
        //   {element: '.collection_with_options-grid-item[data-product="14-inch-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$269' },
        //   {element: '.collection_with_options-grid-item[data-product="16-inch-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$289' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-small-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$339' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-large-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$399' },
          {element: '.collection_with_options-grid-item[data-product="24-inch-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$429' },
        //   {element: '.collection_with_options-grid-item[data-product="26-inch-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$549' },
          // {element: '#shopify-section-status-bar .status-bar-text', type: 'innerText', value: "VARIANT A or GOOGLE EXCLUSION" },
          
        ]
      },
      'B': {
        productProperties: [
          { pathnames: ['/products/balance-bike', '/products/14-inch-bike', '/products/16-inch-bike', '/products/20-inch-small-bike', '/products/20-inch-large-bike', '/products/24-inch-bike', '/products/26-inch-bike'], key: "_gbab", value: "T001-B" }
        ],
        selectors: [
        //   {element: '.product-template[data-product-id=\"6777668730973\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 0},
        //   {element: '.product-template[data-product-id=\"6777668730973\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 0},
        //   {element: '.product-template[data-product-id=\"4837251022941\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 0},
        //   {element: '.product-template[data-product-id=\"4837251022941\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 0},
        //   {element: '.product-template[data-product-id=\"4837240602717\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 0},
        //   {element: '.product-template[data-product-id=\"4837240602717\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 0},
          {element: '.product-template[data-product-id=\"4837430001757\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 0},
          {element: '.product-template[data-product-id=\"4837430001757\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 0},
          {element: '.product-template[data-product-id=\"4837426954333\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 0},
          {element: '.product-template[data-product-id=\"4837426954333\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 0},
          {element: '.product-template[data-product-id=\"4837430394973\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 0},
          {element: '.product-template[data-product-id=\"4837430394973\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 0},
        //   {element: '.product-template[data-product-id=\"6971986903133\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(2)', type: 'price', discount: 0},
        //   {element: '.product-template[data-product-id=\"6971986903133\"] .product-title-desktop > div:nth-of-type(4) > div:nth-of-type(1) > p:nth-of-type(1)', type: 'price', discount: 0},
        //   {element: '.collection_with_options-grid-item[data-product="balance-bike"] .collection_with_options-price', type: 'innerText', value: '$159' },
        //   {element: '.collection_with_options-grid-item[data-product="14-inch-bike"] .collection_with_options-price', type: 'innerText', value: '$259' },
        //   {element: '.collection_with_options-grid-item[data-product="16-inch-bike"] .collection_with_options-price', type: 'innerText', value: '$259' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-small-bike"] .collection_with_options-price', type: 'innerText', value: '$299' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-large-bike"] .collection_with_options-price', type: 'innerText', value: '$329' },
          {element: '.collection_with_options-grid-item[data-product="24-inch-bike"] .collection_with_options-price', type: 'innerText', value: '$349' },
        //   {element: '.collection_with_options-grid-item[data-product="26-inch-bike"] .collection_with_options-price', type: 'innerText', value: '$409' },
        //   {element: '.collection_with_options-grid-item[data-product="balance-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$209' },
        //   {element: '.collection_with_options-grid-item[data-product="14-inch-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$279' },
        //   {element: '.collection_with_options-grid-item[data-product="16-inch-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$299' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-small-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$349' },
          {element: '.collection_with_options-grid-item[data-product="20-inch-large-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$409' },
          {element: '.collection_with_options-grid-item[data-product="24-inch-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$439' },
        //   {element: '.collection_with_options-grid-item[data-product="26-inch-bike"] .collection_with_options-compare-price strike', type: 'innerText', value: '$579' },
          // {element: '#shopify-section-status-bar .status-bar-text', type: 'innerText', value: "VARIANT B" },
        ]
      }
    }
  },
  'T002': {
    enabled: false,
    variants: {
      'A': {
        productProperties: [],
        selectors: []
      },
      'B': {
        productProperties: [],
        selectors: [
          {element: '.how-surestop-works-link .video-underline', type: 'innerText', value: 'LEARN TO RIDE IN 1 DAY™'},
        ]
      }
    }
  }
};

function addCSSRule(selector, rules) {
  // Create a style element if it doesn't exist
  if (!window.dynamicStyles) {
    window.dynamicStyles = document.createElement('style');
    window.dynamicStyles.type = 'text/css';
    document.head.appendChild(window.dynamicStyles);
  }

  // Append the new rule
  const sheet = window.dynamicStyles.sheet;
  const ruleIndex = sheet.cssRules.length;
  sheet.insertRule(`${selector} { ${rules} }`, ruleIndex);
}
function abSetCookie (name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function abGetCookie (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie (name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}



function abSetLocalStorage(name, value, days) {
  const item = {
    value: value,
    expiry: days ? new Date().getTime() + (days * 24 * 60 * 60 * 1000) : null
  };
  localStorage.setItem(name, JSON.stringify(item));
}

function abGetLocalStorage(name) {
  const itemStr = localStorage.getItem(name);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  if (item.expiry && new Date().getTime() > item.expiry) {
    localStorage.removeItem(name);
    return null;
  }
  return item.value;
}

function eraseLocalStorage(name) {
  localStorage.removeItem(name);
}





function abAddProductProperty(key, value) {
  let keySlug = key.replaceAll(' ', '_')
  var input = $('<input id="preorded-property-'+keySlug+'" type="hidden" name="properties['+key+']" value="'+value+'" />')[0]
  $("#AddToCartForm").append(input)
}
// Function to randomly select a variant
function selectRandomVariant(test) {
  const variants = Object.keys(test.variants);
  return variants[Math.floor(Math.random() * variants.length)];
}
  
function gbFormatPrice (cents) {
  if (cents%100 == 0) {
    return "$"+(cents/100)
  } else {
    return (cents/100).toLocaleString("en-US", {style:"currency", currency:"USD"})
  }
}

function gbGetQueryParam(param) {
  var urlParams = new URLSearchParams(window.location.search);
  var paramValue = urlParams.get(param);
  return paramValue;
}

// Function to apply the variant
function applyVariant(testName, variant, applyProperties) {
  const testVariant = tests[testName]['variants'][variant];
  
  let testVariantSelectors = testVariant.selectors

  testVariant.selectors.forEach(selector => {
    const testVariantSelectorElements = document.querySelectorAll(selector.element);
    testVariantSelectorElements.forEach(element => {
      if (selector.type === 'innerText') {
        element.innerText = selector.value
      } if (selector.type === 'price') {
        let currentPrice = element.dataset.gbPrice
        let newPrice = currentPrice - selector.discount
        element.innerText = gbFormatPrice(newPrice)
      }
      element.style.visibility = 'visible'
    })
  })
  
  // for (let i=0;i<testVariantSelectors.length;i++) {
  //   const testVariantSelector = testVariantSelectors[i];
  //   const testVariantSelectorElements = document.querySelectorAll(testVariantSelector.element);
  //   testVariantSelectorElements.forEach(element => {
  //     if (testVariantSelector.type === 'innerText') {
  //       element.innerText = testVariantSelector.value
  //     } if (testVariantSelector.type === 'price') {
  //       let currentPrice = element.dataset.gbPrice
  //       let newPrice = currentPrice - testVariantSelector.discount
  //       element.innerText = gbFormatPrice(newPrice)
  //     }
  //     element.style.visibility = 'visible'
  //   })
  // }

  if (applyProperties) {
    let testVariantProductProperties = testVariant.productProperties
    for (let i=0;i<testVariantProductProperties.length;i++) {
      const testVariantProductProperty = testVariantProductProperties[i]
      if (testVariantProductProperty.pathnames.includes(window.location.pathname)) {
        abAddProductProperty(testVariantProductProperty.key, testVariantProductProperty.value)
      }
    }
  }

  
}



// Run all tests
function runTests(variant) {

  
  for (let testName in tests) {
    let test = tests[testName]
    if (!test.enabled) {
      continue;
    }
    // let variant = abGetCookie(`gbab_${testName}`)
    if (!variant) {
      variant = selectRandomVariant(test);
      // abSetCookie(`gbab_${testName}`, variant)
    }
    applyVariant(testName, variant, true);
  }
}

function setABTestGroup(testName,  variant){
  // console.log("SETTING AB TEST GROUP", testName,  variant)
  snowplow("trackStructEvent", {
    category: "GBAB",
    action: testName,
    label: variant
  });
}


function hideABTestCSS() {
  for (let testName in tests) {
    let test = tests[testName]
    if (!test.enabled) {
      // console.log("Test", testName, "not enabled")
      continue;
    }
    let variant = abGetLocalStorage(`gbab_${testName}`)
    if (!variant) {
      variant = selectRandomVariant(test);
      abSetLocalStorage(`gbab_${testName}`, variant)
      setABTestGroup(testName,  variant)
    } else {
      console.log("Loaded variant from storage.")
    }
    const testVariant = tests[testName]['variants'][variant];
    testVariant.selectors.forEach(selector => {
      addCSSRule(selector.element, "visibility: hidden;")
    })
    // console.log("["+testName+"] In group", variant)
    return variant
  }
}
function hideControlCSS() {
  for (let testName in tests) {
    let test = tests[testName]
    const testVariant = tests[testName]['variants']["A"];
    testVariant.selectors.forEach(selector => {
      addCSSRule(selector.element, "visibility: hidden;")
    })
  }
}


function applyExcludedControl() {
  for (let testName in tests) {
    // console.log("["+testName+"] In excluded control")
    applyVariant(testName, "A", false);
  }
}

let skipGoogle = false
let utmSource = gbGetQueryParam('utm_source');
let utmMedium = gbGetQueryParam('utm_medium');
let utmCampaign = gbGetQueryParam('utm_campaign');
if (skipGoogle && utmSource && utmMedium && utmCampaign) {
  let utmSourceLower = utmSource.toLowerCase()
  let utmMediumLower = utmMedium.toLowerCase()
  let utmCampaignLower = utmCampaign.toLowerCase()
  let campaignContainsShopOrPmax = ['p.max', 'shopping'].some(function(value) {
    return utmCampaignLower.indexOf(value) !== -1;
  });

  if (utmSourceLower == 'google' && utmMediumLower == 'cpc' && campaignContainsShopOrPmax) {
    console.log("EXCLUDE FROM TEST")
    hideControlCSS()
    // Run tests as soon as the DOM is ready
    if (document.readyState !== 'loading') {
      applyExcludedControl()
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        applyExcludedControl()
      });
    }
  }
} else {
  let variant = hideABTestCSS()
  // Run tests as soon as the DOM is ready
  if (document.readyState !== 'loading') {
    runTests(variant);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      runTests(variant)
    });
  }
}



